import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { AUTHORS_EMAIL_ID } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';

@Component({
  selector: 'app-author-email-id',
  templateUrl: './author-email-id.component.html',
  styleUrls: ['./author-email-id.component.css'],
})
export class AuthorEmailIdComponent implements OnInit {
  constructor(private _requestService: RequestService) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  emailAddress: string = '';

  ngOnInit(): void {
    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = AUTHORS_EMAIL_ID) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      email: this.emailAddress,
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      AUTHORS_EMAIL_ID,
      {
        is_download: 1,
        email: this.emailAddress,
        page: this.currentPage,
      },
      '',
      'finance_authors_email'
    );
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      email: this.emailAddress,
      page: this.currentPage,
    });

    this.loadProducts(this.createPostData());
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    //console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    this.emailAddress = '';
  }
}
